module.exports = __webpack_public_path__ + "static/media/mhart.69f9969d.jpg";